export default "__VITE_ASSET__KgNKsvkm__"